import { z } from 'zod';
export const NlqPersonaSchema = z.enum(['BA', 'DEVELOPER', 'ARCHITECT']);
export const NlqRenderModeSchema = z.enum(['HIGHLIGHT', 'FILTER']);
export const NlqExecuteRequestSchema = z.object({
    queryText: z.string().trim().min(1, 'queryText is required'),
    persona: NlqPersonaSchema.optional().default('DEVELOPER'),
    maxDepth: z.coerce.number().int().min(1).max(50).optional(),
    maxNodes: z.coerce.number().int().min(1).max(20000).optional(),
    renderMode: NlqRenderModeSchema.optional().default('HIGHLIGHT'),
});
//# sourceMappingURL=nlqDependencyQuery.schema.js.map